import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { PORTUGAL_BOUNDS } from '../../types';

import 'leaflet/dist/leaflet.css';

interface MapShellProps {
  children: React.ReactNode;
  tileUrl?: string;
  tileAttribution?: string;
  tileKey?: string;
  zoomControl?: boolean;
  className?: string;
}

export default function MapShell({
  children,
  tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  tileAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  tileKey,
  zoomControl = true,
  className = 'h-full w-full',
}: MapShellProps) {
  return (
    <MapContainer
      center={[PORTUGAL_BOUNDS.center.lat, PORTUGAL_BOUNDS.center.lon]}
      zoom={7}
      className={className}
      zoomControl={false}
    >
      <TileLayer
        key={tileKey}
        attribution={tileAttribution}
        url={tileUrl}
      />
      {zoomControl && <ZoomControl position="bottomright" />}
      {children}
    </MapContainer>
  );
}
